"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcBreadcrumb(props) {
  var items = props.items,
    separator = props.separator,
    href = props.href;
  var displayItems = function displayItems() {
    if (items && items.length) {
      return items.map(function (item) {
        if (href) {
          return /*#__PURE__*/_react["default"].createElement(_lib.Breadcrumb.Item, {
            href: href
          }, item);
        }
        return /*#__PURE__*/_react["default"].createElement(_lib.Breadcrumb.Item, null, item);
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_lib.Breadcrumb, {
    separator: separator
  }, displayItems(), " ");
}
var _default = ArcBreadcrumb;
exports["default"] = _default;